// extracted by mini-css-extract-plugin
module.exports = {"root":"PageContainer_root__6_bVH","content":"PageContainer_content__TPvx5"};